// Graph Builderのヘッダーコンポーネント
import { DatasetId, DataSet } from '../../../types';
import { FilterInput } from './FilterInput';
import * as styles from '../../styles/components/graph-builder.css.ts';

interface GraphBuilderHeaderProps {
  datasets: Record<DatasetId, DataSet>;
  filterExpression?: string;
  selectedDataset?: DataSet;
  onDatasetChange: (datasetId: string) => void;
  onFilterChange: (expression: string | undefined) => void;
}

export function GraphBuilderHeader({
  datasets,
  filterExpression,
  selectedDataset,
  onDatasetChange,
  onFilterChange
}: GraphBuilderHeaderProps) {
  const datasetList = Object.values(datasets);

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>Graph Builder</h1>
        {datasetList.length > 0 && (
          <div className={styles.headerDatasetSelector}>
            <select
              data-testid="header-dataset-select"
              className={styles.headerDatasetDropdown}
              value={selectedDataset?.id || ''}
              onChange={(e) => onDatasetChange(e.target.value)}
            >
              <option value="" disabled>Select a dataset</option>
              {datasetList.map((ds) => (
                <option key={ds.id} value={ds.id}>
                  {ds.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* フィルタ設定 - データセット選択の直後 */}
        {selectedDataset && (
          <div className={styles.headerFilterSection}>
            <label className={styles.settingLabel}>Filter</label>
            <FilterInput
              value={filterExpression || ''}
              onChange={(expression) => {
                onFilterChange(expression || undefined);
              }}
              dataset={selectedDataset}
            />
          </div>
        )}
      </div>
    </div>
  );
}